import { Hidden } from '@mui/material'
import { TailSpin } from 'react-loading-icons'
import { ContentPageView } from 'src/components/ContentPage/ContentPageView'
import { ContentPagination } from 'src/components/ContentPagination/ContentPagination'
import { SearchField } from 'src/components/global/SearchField'
import { ReCaptcha } from 'src/components/ReCaptcha/ReCaptcha'
import { IEnum_Content_Contenttype, useVendorAnalysisBySolutionIdQuery } from 'src/graphql/generated/hooks'

interface VendorAnalysisContainerProps {
  solutionId: string
  analysisTotal?: number
}

const SolutionVendorAnalysisContainer: React.FC<VendorAnalysisContainerProps> = ({ solutionId, analysisTotal = 0 }) => {
  if (analysisTotal > 1) {
    return (
      <ReCaptcha>
        <div className="flex flex-col justify-center w-full md:pl-0 md:pr-0 pl-[20px] pr-[20px]">
          <div className="flex flex-row justify-center w-full">
            <div className="!max-w-[1100px] flex flex-row justify-between w-full mb-32">
              {analysisTotal > 2 && (
                <Hidden mdDown>
                  <div className="w-1/4 pr-10 flex flex-col">
                    <SearchField className="my-8" />
                  </div>
                </Hidden>
              )}

              <ContentPagination
                contentType={IEnum_Content_Contenttype.VendorAnalysis}
                preAppliedFilters={{ resourceSolutionIds: solutionId }}
                filterProps={[]}
              />
            </div>
          </div>
        </div>
      </ReCaptcha>
    )
  } else {
    const { data: contentsData, loading } = useVendorAnalysisBySolutionIdQuery({
      variables: { solutionId },
    })
    const items = contentsData?.contents?.data || []
    const contentSlug = items.length > 0 ? items[0]?.attributes?.slug : null
    const contentSnippet = items.length > 0 ? items[0]?.attributes?.snippet : null

    return (
      <>
        {loading && (
          <div className="w-full flex items-center justify-center my-[40px]">
            <TailSpin stroke="#011D58" height="2em" /> <div className="pl-3"> Loading...</div>
          </div>
        )}
        {!loading && contentSlug && contentSnippet && (
          <ContentPageView slug={contentSlug} contentSnippet={contentSnippet} />
        )}
      </>
    )
  }
}

export default SolutionVendorAnalysisContainer
